/**
 * tutorEarningsFormatter — comment le mois de paiements du masteur s'écrit (« Mon mois »).
 */
import { type UITutorEarnings, type UITutorEarningsPeriodKey } from "../types/tutorCoquilleAccueil"
import { euros } from "./moneyFormatter"
import { joinFrench } from "./textFormatter"

/** La note de l'astérisque : les chiffres ne comptent pas encore les lives en relecture. */
export const PENDING_REVIEW_NOTE = "*Certains lives en attente de validation ne sont pas encore comptés."

/**
 * Sans compte Stripe, des lives attendent leur relecture : le validé n'en tient pas compte, d'où
 * l'astérisque et sa note. Avec un compte Stripe, ils sont dans « en attente ». Une seule règle pour
 * l'accueil et sa feuille « Détails », qui montrent le même chiffre.
 */
export function showsPendingReview(earnings: UITutorEarnings, period: UITutorEarningsPeriodKey): boolean {
    return earnings.periods[period].pendingReview === true && !earnings.stripeConnected
}

/** « 3 h » — des heures de live, l'espace insécable. */
export function hoursLabel(count: number): string {
    return `${count}\u00A0h`
}

/**
 * Ce qui attend sa validation ce mois-ci, en une ligne sous les chiffres validés : « + 3 h et 42 € en
 * attente », « + 42 € en attente » — les seules parts non nulles. `null` quand rien n'attend.
 */
export function pendingEarningsLabel(hours: number | undefined, amount: number | undefined): string | null {
    const parts: string[] = []
    if (hours != null && hours > 0) parts.push(hoursLabel(hours))
    if (amount != null && amount > 0) parts.push(euros(amount))
    return parts.length > 0 ? `+ ${joinFrench(parts)} en attente` : null
}
